exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".registration-modal__legal-text[data-v-54036a3d]{font-size:12px;font-size:.75rem;margin-bottom:3%}.inline[data-v-54036a3d]{display:inline-block;vertical-align:top;width:49%;margin-bottom:0;margin-top:0}.colored[data-v-54036a3d]{color:#20242e}.unmarked[data-v-54036a3d]{color:inherit}.copyright[data-v-54036a3d]{margin-top:100px;margin-top:6.25rem;color:#8f8f8f;font-size:12px;font-size:.75rem}@media (max-width:599px){.name[data-v-54036a3d]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54036a3d","scoped":true,"hasInlineConfig":false}!./~/postcss-loader!./~/sass-loader/lib/loader.js!./app/components/registration-modal/style.scss
// module id = 246
// module chunks = 0